import { Modal } from "@/components/common/Modal/Modal"
import { toast } from "@/components/common/Toast"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useDeleteKnowledgebaseFile } from "@/services/api/knowledgebaseService"
import { useRefetchItems } from "@/utils/context/refetchItemsStackedList"
import { IconTrash } from "@tabler/icons-react"
import { useEffect } from "react"

interface DeleteDocumentModalProps {
  fileId: string
  setIsDeleteModalOpen: (isOpen: boolean) => void
}

export const DeleteDocumentModal: React.FC<DeleteDocumentModalProps> = ({
  fileId,
  setIsDeleteModalOpen,
}) => {
  const { translate } = useTranslation()
  const refechItems = useRefetchItems()

  const {
    mutate: deleteFile,
    isError: isDeleteError,
    isSuccess: isDeleteSuccess,
  } = useDeleteKnowledgebaseFile()

  useEffect(() => {
    if (isDeleteError) {
      toast.error(translate("KNOWLEDGEBASE/FILE_MODAL_DELETE_ERROR"))
    } else if (isDeleteSuccess) {
      setIsDeleteModalOpen(false)
      toast.success(translate("KNOWLEDGEBASE/FILE_MODAL_DELETE_SUCCESS"))
      refechItems()
    }
  }, [
    isDeleteError,
    isDeleteSuccess,
    refechItems,
    setIsDeleteModalOpen,
    translate,
  ])

  return (
    <Modal
      showSidebarLeft
      ModalIcon={IconTrash}
      descriptionText={translate("KNOWLEDGEBASE/FILE_MODAL_DESCRIPTION")}
      primaryActionTitle={translate("KNOWLEDGEBASE/FILE_MODAL_PRIMARY_ACTION")}
      secondaryActionTitle={translate(
        "KNOWLEDGEBASE/FILE_MODAL_SECONDARY_ACTION",
      )}
      onClose={() => {
        setIsDeleteModalOpen(false)
      }}
      onPrimaryAction={() => deleteFile(fileId)}
      onSecondaryAction={() => {
        setIsDeleteModalOpen(false)
      }}
    />
  )
}
